import oldMessageMap from "./error-code-old";
import newMessageMap from "./error-code";

const messageMap = {
    ...newMessageMap,
    ...oldMessageMap
}

export function getRequestErrorMessage(code: string, msg?: string) {
    // if ((messageMap as Record<string, string>)[code]) {
    //     return (messageMap as Record<string, string>)[code];
    // }
    if ((messageMap as Record<string, Function>)[code]) {
        try {
            const message = (messageMap as Record<string, Function>)[code]();
            return message;
        } catch (error) {
            console.error(`Failed to get error message for code ${code}:`, error);
            return msg || WordList.OperationFailed;
        }
    }
    return msg || WordList.OperationFailed;
}
